import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { baseurl, imageUrl } from "../Baseurl";
import { ShoppingCart } from "react-feather";
import { Link } from "react-router-dom";

// Custom Arrow Button
const ArrowButton = ({ className, style, onClick, icon }) => (
  <button
    className={className}
    style={{
      ...style,
      display: "block",
      background: "transparent",
      border: "none",
      color: "#000",
    }}
    onClick={onClick}
  >
    {icon}
  </button>
);

const SimilarProduct = ({ producttitle }) => {
  const [listings, setListings] = useState([]);

console.log("producttitle", producttitle);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const words = producttitle.split(" ").filter((w) => w.length > 2); // filter short/common words
        const allResults = [];

        for (const word of words) {
          const response = await axios.get(`${baseurl}SearchProducts/${word}/1`);
          if (response.data?.sellerListings?.length > 0) {
            allResults.push(...response.data.sellerListings);
          }
        }

        // Remove duplicates based on listing_unique_id or listing_id
        const uniqueListings = Array.from(
          new Map(allResults.map((item) => [item.listing_unique_id || item.listing_id, item])).values()
        );

        setListings(uniqueListings);
      } catch (error) {
        console.error("Error fetching similar products:", error);
      }
    };

    if (producttitle) {
      fetchListings();
    }
  }, [producttitle]);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        },
      },
    ],
  };

  return (
  <div className="product-slider">
    {listings.length > 4 ? (
      <Slider {...settings}>
        {listings.map((Listing) => {
          const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
          const findFirstImage = (images) =>
            images?.find((img) =>
              imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
            );
          const imageToDisplay = findFirstImage(Listing.images) || "default-image.jpg";

          return (
            <div className="product-card" key={Listing.listing_unique_id || Listing.listing_id}>
              <img src={`${imageUrl}listing/${imageToDisplay}`} alt={Listing.title} />
              <p className="brand">{Listing.brand_name}</p>
              <h3>{Listing.title}</h3>
              <div className="rating">
                <span>☆☆☆☆☆</span>
              </div>
              <div className="price">
                {Listing.type === "directSell" ? (
                  <span className="current-price">₹{Listing.price}</span>
                ) : Listing.type === "quoteRequest" ? (
                  <span className="current-price">View Details</span>
                ) : null}
              </div>
              <Link to={`/product/${Listing.slug}`} target="_blank" className="btn add-to-cart">
                <ShoppingCart size={16} />&nbsp;View Details
              </Link>
            </div>
          );
        })}
      </Slider>
    ) : (
      <div className="d-flex flex-wrap gap-3">
        {listings.map((Listing) => {
          const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
          const findFirstImage = (images) =>
            images?.find((img) =>
              imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
            );
          const imageToDisplay = findFirstImage(Listing.images) || "default-image.jpg";

          return (
            <div
              className="product-card"
              style={{ flex: "0 0 auto", width: "220px" }}
              key={Listing.listing_unique_id || Listing.listing_id}
            >
              <img src={`${imageUrl}listing/${imageToDisplay}`} alt={Listing.title} />
              <div className="p-2">
                <p className="brand">{Listing.brand_name}</p>
              <h3>{Listing.title}</h3>
              <div className="rating">
                <span>☆☆☆☆☆</span>
              </div>
              <div className="price">
                {Listing.type === "directSell" ? (
                  <span className="current-price">₹{Listing.price}</span>
                ) : Listing.type === "quoteRequest" ? (
                  <span className="current-price">View Details</span>
                ) : null}
              </div>
              <Link to={`/product/${Listing.slug}`} target="_blank" className="btn add-to-cart">
                <ShoppingCart size={16} />&nbsp;View Details
              </Link>
              </div>
              
            </div>
          );
        })}
      </div>
    )}
  </div>
);

};

export default SimilarProduct;
